<template>
  <Transition name="slide" mode="out-in">
    <div class="modal" v-if="showModal" :key="'modalIos'">
      <div class="modal-content">
        <div class="modal-content__icon">
          <IconX @click="closeModal" class="top-to-bottom--effect" />
        </div>
        <img src="@/assets/img/logo-text.png" class="modal-content__logo" />
        <div class="modal-content__description">
          <span>
            {{ $t('ios.modal.instructions') }}
          </span>
        </div>
        <img
          src="@/assets/img/pwa_ios_step_1.png"
          class="modal-content__instructions"
        />
        <img
          src="@/assets/img/pwa_ios_step_2.png"
          class="modal-content__instructions"
        />
        <slot name="content" />
      </div>
    </div>
  </Transition>
</template>
<script setup>
  import { IconX } from '@tabler/icons-vue'

  const props = defineProps({
    showModal: { type: Boolean },
    modalEffect: { type: String, default: 'left-to-right--effect' }
  })

  const emits = defineEmits(['closePwaModal'])

  const closeModal = () => {
    emits('closePwaModal')
  }
</script>
<style scoped lang="scss">
  @import '@/scss/mixings';
  .modal {
    @include d-flex(row, center, center);
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 100;
    .modal-content {
      @include d-flex(column, flex-start, center);
      gap: 20px;
      padding: 6vw;
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      background: $white;
      &__icon {
        @include d-flex(row, flex-end, flex-end);
        align-self: end;
      }
      &__logo {
        width: 200px;
        height: auto;
      }
      &__description {
        text-align: center;
        font-weight: 400;
      }
      &__instructions {
        width: 100%;
        img {
          width: 100%;
          height: auto;
        }
      }
    }
  }
</style>
